const LOCAL_ROUTES = new Set(["/", "/grid", "/advisory", "/sobre", "/contato"]);
const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)");
const saveData = (navigator as Navigator & { connection?: { saveData?: boolean } })
  .connection?.saveData;

function cleanPath(path: string): string {
  const clean = path.replace(/\.html$/, "").replace(/\/index$/, "").replace(/\/+$/, "");
  return clean || "/";
}

function localRoute(link: HTMLAnchorElement): URL | null {
  if (link.target || link.hasAttribute("download")) return null;
  const url = new URL(link.href, window.location.href);
  if (url.origin !== window.location.origin || !LOCAL_ROUTES.has(cleanPath(url.pathname))) return null;
  return url;
}

function prefetch(url: URL): void {
  if (saveData || document.querySelector(`link[data-route-prefetch="${url.pathname}"]`)) return;
  const hint = document.createElement("link");
  hint.rel = "prefetch";
  hint.as = "document";
  hint.href = url.pathname + url.search;
  hint.dataset.routePrefetch = url.pathname;
  document.head.append(hint);
}

export function initRouteMotion(): void {
  document.querySelectorAll<HTMLAnchorElement>("a[href]").forEach((link) => {
    const url = localRoute(link);
    if (!url) return;

    link.addEventListener("pointerenter", () => prefetch(url), { once: true, passive: true });
    link.addEventListener("focus", () => prefetch(url), { once: true, passive: true });

    link.addEventListener("click", (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const current = cleanPath(window.location.pathname);
      const destination = cleanPath(url.pathname);
      if (current === destination && url.hash) return;
      if (current === destination) return;

      event.preventDefault();
      if (reducedMotion.matches) {
        window.location.assign(url.href);
        return;
      }
      document.body.classList.add("is-leaving");
      window.setTimeout(() => window.location.assign(url.href), 170);
    });
  });
}
